
const en = {
    home: {
      seo: {
        title: "Dt. Mert Sakarya Dental Clinic - Bayrampaşa, Istanbul | Implants, Aesthetic Dentistry, Orthodontics",
        description: "Dt. Mert Sakarya Dental Clinic in Bayrampaşa, Istanbul offers dental implants, aesthetic dentistry, root canal treatment, orthodontics, teeth whitening and more. Book your appointment via WhatsApp.",
      },
    },
    blogPage: {
      heroTitle: "Blog",
      heroSubtitle: "Up-to-date articles on dental health, aesthetics, and treatment methods.",
      readMore: "Read More",
      seoTitle: "Blog - Dt. Mert Sakarya Dental Clinic",
      seoDescription: "Articles on dental health, aesthetic dentistry, treatment costs and information for international patients from Dt. Mert Sakarya Dental Clinic.",
      notFoundTitle: "Post Not Found",
      notFoundText: "The blog post you're looking for may have been removed or moved.",
      backToBlog: "Back to Blog",
      allPosts: "All Posts",
    },
    about: {
        eyebrow: "OUR CLINIC",
        title: "About Us",
        paragraph1: "As Dt. Mert Sakarya Dental Clinic, we make healthy, aesthetic smiles accessible to everyone. We combine modern techniques with an experienced team, upholding strict hygiene standards for a reliable, comfortable treatment experience.",
        paragraph2: "",
        showMore: "Show More",
        showLess: "Show Less",
        missionTitle: "Our Mission",
        missionText: "Beyond dental health, we deliver a personalized, comfortable experience built on aesthetics, transparency, trust, and hygiene.",
        visionTitle: "Our Vision",
        visionText: "To be a clinic recognized across Turkey for innovative treatments and the highest level of patient satisfaction.",
        valuesTitle: "Our Values",
        valuesText: "Experience professional, reliable dental care at Dt. Mert Sakarya Dental Clinic."
      },
      info: {
        doctor: "DOCTOR",
        doctorCount: "4+",
        happyTreatments: "HAPPY TREATMENTS",
        happyTreatmentsCount: "14000+",
        activeClinics: "ACTIVE CLINICS",
        activeClinicsCount: "4+",
        services: "SERVICES",
        servicesCount: "50+"
      },
      hero: {
        title: "Healthy and Aesthetic Smiles",
        subtitle: "Safe and modern dental treatments with Dt.Mert Sakarya Clinic",
        button: "Book Appointment",
        labels: ["Natural Smile", "Digital Technology", "Expert Care"],
        quote: "Every tooth in a person's head is worth more than a diamond.",
        quoteAuthor: "Miguel de Cervantes, Don Quixote, 1605",
        doctorsPreview: [
          { name: "Hakan Kayhan", tagline: "Prosthetics & Smile Design" },
          { name: "Mert Sakarya", tagline: "Implant & Prosthetics Specialist" }
        ]
      },
      whatsapp: {
  greeting: "Hello, I'm reaching out via the Dt. Mert Sakarya Clinic website!",
  cta: "Message us on WhatsApp!",
},
contact: {
  title: "Contact",
  seoDescription: "Get in touch with Dt. Mert Sakarya Dental Clinic in Bayrampaşa, Istanbul: address, phone, WhatsApp and directions to book your appointment.",
  bookOnline: "Book Online",
  bookOnlineSubtitle: "Choose your treatment and doctor, and pick a suitable appointment time in a few steps.",
  bookOnlineFallback: "If the booking form doesn't appear, click here",
  address: "Address",
  reachUs: "Reach Us",
  hours: "Working Hours",
  newMessage: "New patient message:",
  name: "Name",
  email: "Email",
  phone: "Phone",
  message: "Message",
  sending: "Redirecting to WhatsApp...",
  namePlaceholder: "Your Name",
  emailPlaceholder: "Email",
  phonePlaceholder: "Phone",
  messagePlaceholder: "Your Message",
  sendingButton: "Sending...",
  sendButton: "Send via WhatsApp"
},
map: {
  eyebrow: "GETTING HERE",
  title: "Our Location",
  subtitle: "We're located in the heart of Bayrampaşa, easy to reach."
},
reviews: {
  eyebrow: "PATIENT REVIEWS",
  title: "Google Reviews"
},
doctors: {
      eyebrow: "EXPERT TEAM",
      title: "Our Doctors",
      seoDescription: "Meet the experienced dentists at Dt. Mert Sakarya Dental Clinic in Bayrampaşa, Istanbul.",
      list: [
        {
          name: "Hakan Kayhan",
          title: "Dentist",
          description:
            "Dentist Hakan Kayhan graduated from the Faculty of Dentistry at Bezmialem Vakıf University in 2019. After graduation, he worked as a dentist in various hospitals and polyclinics. With his expertise in prosthetic treatments and smile design, he helps his patients achieve healthy and aesthetic smiles."
        },
        {
          name: "Mert Sakarya",
          title: "Dentist",
          description:
            "Dentist Mert Sakarya graduated from the Faculty of Dentistry at Bezmialem Vakıf University. Following his graduation, he worked as a dentist in his own private practice.With his expertise in implant and prosthetic treatments, he helps his patients achieve healthy and aesthetic smiles."
        }
      ]
    },
    services: {
  eyebrow: "WHAT WE OFFER",
  title: "Our Services",
  details: "See Details",
  cards: [
    { text: "Dental Implants", description: "Professional implant solutions to restore missing teeth, improving both your appearance and quality of life.", link: "/implant" },
    { text: "Cosmetic Dentistry", description: "Perfect your smile with treatments like smile design, Hollywood Smile, bonding, and other cosmetic procedures.", link: "/estetik-dis" },
    { text: "Root Canal Treatment", description: "Modern root canal treatments to save infected teeth and protect your oral health.", link: "/kanal" },
    { text: "Teeth Whitening", description: "Achieve dazzling white teeth with safe and effective whitening methods.", link: "/dis-beyazlatma" },
    { text: "Pediatric Dentistry", description: "Comfortable and safe dental treatments designed specifically for children.", link: "/cocuk-dis" },
    { text: "Braces Treatment", description: "Orthodontic treatments to correct teeth and jaw alignment, providing an aesthetic smile.", link: "/dis-teli" },
    { text: "Gum Treatment", description: "Effective solutions to prevent gum diseases and maintain healthy teeth.", link: "/dis-eti" },
    { text: "Orthodontics", description: "Precise and effective orthodontic solutions for the ideal smile.", link: "/ortodonti" },
    { text: "Bruxism Treatment", description: "Eliminate teeth grinding problems and protect your teeth.", link: "/bruksizm" }
  ]
},
footer: {
        addressTitle: "Address",
        addressLine1: "Yıldırım, Ali Fuat Başgil Cd. No:122/A",
        addressLine2: "34045 Bayrampaşa / Istanbul",
        contactTitle: "Contact Us",
        phone1: "+90 531 964 2737",
        phone2: "+90 212 640 6061",
        hoursTitle: "Working Hours",
        hoursWeek: "Mon-Fri: 11.00 - 23.00",
        hoursWeekend: "Sat-Sun: 11.00 - 17.00",
        copyright: "© 2026 Mert Sakarya Clinic. All Rights Reserved.",
        seoText: "Teeth Whitening, Dental Prosthesis, Implant, Porcelain Teeth, Root Canal, Dental Filling, Orthodontics, Dental Veneer, Zirconium Crown, Braces, Transparent Tray, Bayrampaşa Dental Clinic, Smile Design, Hollywood Smile, Dental Clinic, Istanbul Dental, Turkey Dental"
      },
      navbar: {
        home: "Mert Sakarya Clinic",
        team: "Our Team",
        about: "About Us",
        prices: "Price List",
        blog: "Blog",
        contact: "Contact",
      },
       price: {
    title: "Price List",
    seoTitle: "Dental Treatment Prices - Dt. Mert Sakarya Dental Clinic (Bayrampaşa, Istanbul)",
    seoDescription: "Transparent dental treatment prices in Istanbul: implants, prosthesis, orthodontics, whitening and more, with approximate USD/EUR equivalents.",
    currencyNote: "Prices are charged in Turkish Lira (₺). USD/EUR figures are approximate, based on current exchange rates, and provided as a guide only — your exact quote is confirmed after a free consultation.",
    tableHeaders: { treatment: "Treatment", range: "Price Range" },
    kanalDolgu: {
      title: "Canal & Filling Treatments",
      dolgu: "Filling",
      kanal: "Canal",
      retreatment: "Retreatment",
    },
    cocuk: {
      title: "Children's Dental Treatments",
      dolgu: "Filling",
      kanal: "Canal",
      disCekimi: "Tooth Extraction",
      sutDisCekimi: "Milk Tooth Extraction",
      amputasyon: "Amputation",
      yerTutucu: "Space Maintainer",
    },
    disCekimi: {
      title: "Tooth Extraction Treatments",
      disCekimi: "Tooth Extraction",
      komplikasyonlu: "Complicated Tooth Extraction",
      yirmilik: "Wisdom Tooth Extraction",
      gomulu: "Impacted Tooth Extraction",
    },
    estetik: {
      title: "Aesthetic Dental Treatments",
      estetikDolgu: "Aesthetic Filling",
      disBeyazlatma: "Teeth Whitening",
      disTasTemizligi: "Dental Cleaning",
      zirkonyum: "Zirconium Crown",
      yaprakLamina: "Veneer Lamina",
      eMax: "E-MAX",
    },
    implant: {
      title: "Implant Treatment Prices",
      ithal: "Imported Implant (Prosthesis Excluded)",
      premiumIthal: "Premium Imported Implant (Prosthesis Excluded)",
    },
    protez: {
      title: "Prosthesis Treatments",
      total: "Total Prosthesis (Single Jaw)",
      ustuTotal: "Implant-Supported Total Prosthesis",
      porselen: "Porcelain Crown",
    },
    ortodonti: {
      title: "Orthodontic Treatments",
      tel: "Wire Braces",
      telsiz: "Clear Aligners",
    },
  },
  common: {
    bookAppointment: "Book Appointment",
  },
  implant: {
    seo: {
      title: "Implant Treatment - dtMertSakarya",
      description: "Restore missing teeth and achieve healthy smiles. Modern and safe implant treatment solutions.",
    },
    hero: {
      heading: "Implant Treatment",
      text: "Modern implant solutions that restore your missing teeth, improving both your appearance and quality of life. Healthy smiles with comfortable and safe procedures.",
      button: "Make an Appointment",
    },
    details: {
      heading: "Why Implant?",
      text: "Implants restore natural tooth appearance and function, provide chewing comfort, and support jawbone health. They are a long-lasting and reliable solution.",
    },
    steps: [
      "Examination and planning",
      "Implant placement surgery",
      "Healing and follow-up process",
      "Prosthesis application"
    ],
    advantages: {
      heading: "Advantages of Implant Treatment",
      items: [
        { title: "Natural Appearance", desc: "Looks and feels like natural teeth." },
        { title: "Long-lasting", desc: "Can be used for years without issues with proper care." },
        { title: "Bone Health", desc: "Protects jawbone and prevents bone loss." },
        { title: "Comfortable Chewing", desc: "Provides comfortable chewing like natural teeth." }
      ],
    },
  },
  whitening: {
    "metaTitle": "Teeth Whitening - dtMertSakarya",
    "metaDescription": "Achieve a bright smile with safe and effective teeth whitening treatments. Both in-clinic and at-home options available.",
    "title": "Teeth Whitening",
    "description": "Achieve shiny white teeth with safe and effective whitening methods. Get a healthy, aesthetic smile with modern at-home or clinical treatments.",
    "whyTitle": "Why Teeth Whitening?",
    "whyText": "Over time, teeth may discolor due to tea, coffee, smoking, and aging. Professional whitening restores natural whiteness for an aesthetic smile.",
    "steps": [
      "Examination and dental check-up",
      "Whitening plan preparation",
      "Application process",
      "Aftercare and recommendations"
    ],
    "advantagesTitle": "Advantages of Whitening",
    "advantages": [
      {
        "title": "Aesthetic Smile",
        "desc": "Brighter and more attractive smile."
      },
      {
        "title": "Quick Results",
        "desc": "Visible whitening in a short time."
      },
      {
        "title": "Safe Method",
        "desc": "Professional techniques that don’t harm tooth enamel."
      },
      {
        "title": "Long-lasting",
        "desc": "Whiteness maintained for a long time with proper care."
      }
    ]
  }, bruxism:{
  "metaTitle": "Bruxism Treatment - dtMertSakarya",
  "metaDescription": "Modern bruxism treatments that eliminate teeth grinding. Protect your teeth and jaw health.",
  "title": "Bruxism Treatment",
  "description": "Modern solutions that eliminate teeth grinding and clenching problems, protecting your teeth and jaw health.",
  "whyTitle": "What is Bruxism?",
  "whyText": "Bruxism is a common condition where people clench or grind their teeth, usually during sleep. Over time, it can cause tooth wear, jaw pain, and headaches.",
  "steps": [
    "Diagnosis and evaluation",
    "Mouth guard (night guard) application",
    "Jaw exercises and follow-up",
    "Dental restoration if needed"
  ],
  "advantagesTitle": "Benefits of Bruxism Treatment",
  "advantages": [
    { "title": "Dental Health", "desc": "Prevents tooth wear and fractures." },
    { "title": "Jaw Comfort", "desc": "Reduces jaw and joint pain." },
    { "title": "Headache Relief", "desc": "Alleviates morning and nighttime headaches." },
    { "title": "Better Sleep", "desc": "Improves sleep quality and reduces stress." }
  ]
}, gum :{
    "metaTitle": "Gum Treatment - dtMertSakarya",
    "metaDescription": "Modern gum treatments that prevent diseases and maintain healthy teeth.",
    "title": "Gum Treatment",
    "description": "Effective treatments that protect gum health and ensure long-term oral wellness.",
    "whyTitle": "Why Gum Treatment?",
    "whyText": "Healthy gums help keep teeth strong and long-lasting. Treatment prevents inflammation, bleeding, and sensitivity.",
    "steps": [
      "Examination and diagnosis",
      "Tartar and plaque cleaning",
      "Surgical interventions if needed",
      "Follow-up and care recommendations"
    ],
    "advantagesTitle": "Advantages of Gum Treatment",
    "advantages": [
      { "title": "Healthy Teeth", "desc": "Healthy gums protect your teeth for years." },
      { "title": "Oral Hygiene", "desc": "Prevents bacteria and inflammation." },
      { "title": "Comfortable Treatment", "desc": "Minimally invasive, effective solutions." },
      { "title": "Long-Term Results", "desc": "Maintains gum health with proper care." }
    ]
  }, cocuk: {
    seo: {
      title: "Pediatric Dentistry - dtMertSakarya",
      description: "Comfortable and safe dental treatments designed specifically for children, in a friendly and stress-free environment.",
    },
    hero: {
      heading: "Pediatric Dentistry",
      text: "Comfortable and anxiety-free dental care for children, delivered by a friendly team in a child-focused environment that builds trust from the very first visit.",
    },
    details: {
      heading: "Why Pediatric Dentistry?",
      text: "Children's teeth and jaws are still developing, so early check-ups and preventive care matter. We use a gentle, patient approach to help children feel safe and build positive habits around dental visits.",
    },
    steps: [
      "Friendly first examination and getting acquainted",
      "Preventive care: fluoride application and fissure sealants",
      "Treatment of cavities and milk tooth issues",
      "Regular follow-up and habit guidance for parents"
    ],
    advantages: {
      heading: "Advantages of Our Pediatric Dentistry Approach",
      items: [
        { title: "Child-Friendly Environment", desc: "A calm, welcoming space designed to ease children's worries." },
        { title: "Preventive Focus", desc: "Early intervention reduces the risk of bigger problems later." },
        { title: "Gentle Techniques", desc: "Comfortable, age-appropriate treatment methods." },
        { title: "Parent Guidance", desc: "Practical advice on brushing, diet, and home care habits." }
      ],
    },
  }, orthodontics:{
    "meta": {
      "title": "Braces Treatment - dtMertSakarya",
      "description": "Modern orthodontic solutions that improve teeth and jaw alignment for a confident smile."
    },
    "title": "Braces Treatment",
    "subtitle": "Orthodontic treatments that correct teeth and jaw alignment to provide both aesthetic and functional results.",
    "imageAlt": "Braces Treatment",
    "whyTitle": "Why Braces?",
    "whyText": "With braces treatment, your teeth align properly, you gain an aesthetic smile, and chewing function improves.",
    "steps": {
      "1": "Examination and planning",
      "2": "Application of orthodontic appliance",
      "3": "Regular follow-up and adjustments",
      "4": "Completion and retention phase"
    },
    "advantagesTitle": "Advantages of Braces Treatment",
    "advantages": {
      "1": { "title": "Aesthetic Smile", "desc": "Your teeth align correctly for a beautiful smile." },
      "2": { "title": "Functional Improvement", "desc": "Improves chewing and speech functions." },
      "3": { "title": "Long-lasting Results", "desc": "Teeth alignment remains stable after treatment." },
      "4": { "title": "Various Options", "desc": "Metal, clear, and removable braces available." }
    }
  }, esthetic:{
    "seo": {
      "title": "Aesthetic Dentistry - dtMertSakarya",
      "description": "Perfect aesthetic solutions with smile design, Hollywood Smile, and Bonding. Details about aesthetic dentistry."
    },
    "hero": {
      "heading": "Aesthetic Dentistry",
      "text": "Rediscover your smile with aesthetic dental treatments. Achieve a natural and attractive look through professional applications on tooth color, shape, and alignment.",
      "button": "Make an Appointment"
    },
    "details": {
      "heading": "What is Aesthetic Dentistry?",
      "text": "Aesthetic dentistry removes issues related to tooth color, shape, size, and alignment to provide a beautiful smile design. Smile aesthetics applications are planned individually with natural results."
    },
    "steps": [
      "Digital smile design",
      "Porcelain laminate veneer",
      "Composite bonding applications",
      "Teeth whitening procedures"
    ],
    "advantages": {
      "heading": "Advantages of Aesthetic Dentistry",
      "items": [
        { "title": "Natural Smile", "desc": "Provides a natural look in harmony with facial features." },
        { "title": "Fast Results", "desc": "Visible aesthetic changes achieved in a short time." },
        { "title": "Personalized Design", "desc": "Planned according to facial proportions for each patient." },
        { "title": "Long-lasting Effect", "desc": "Applied materials are durable and long-lasting." }
      ]
    }
  },  kanal:{
  "seo": {
    "title": "Root Canal Treatment - dtMertSakarya",
    "description": "Modern root canal methods that save infected teeth and protect oral health. Procedure steps and advantages."
  },
  "hero": {
    "heading": "Root Canal Treatment",
    "text": "Modern root canal methods that remove infections inside the tooth and save it. Painless, comfortable, and effective treatment for a healthy smile."
  },
  "details": {
    "heading": "Why Root Canal Treatment?",
    "text": "Root canal treatment involves cleaning the infected nerve tissue inside the tooth and restoring the tooth structure. This preserves oral health without tooth extraction."
  },
  "steps": [
    "X-ray and examination",
    "Cleaning the canal",
    "Disinfection procedure",
    "Filling and crowning the canal"
  ],
  "advantages": {
    "heading": "Advantages of Root Canal Treatment",
    "items": [
      { "title": "Preserves Natural Tooth", "desc": "Maintains the natural structure instead of extracting the tooth." },
      { "title": "Painless Treatment", "desc": "Comfortable treatment with modern techniques." },
      { "title": "Long-lasting Results", "desc": "Treated tooth lasts for many years without problems." },
      { "title": "Aesthetic Appearance", "desc": "Restoration provides a natural and aesthetic look." }
    ]
  }
}, ortodonti:{
  "seo": {
    "title": "Orthodontics - dtMertSakarya",
    "description": "Precise and effective orthodontic solutions for ideal smile and teeth alignment. Detailed information about orthodontics."
  },
  "hero": {
    "heading": "Orthodontics",
    "text": "Orthodontic treatments correcting teeth and jaw alignment for an aesthetic and healthy smile. Comfortable and effective treatment with modern techniques and personalized planning."
  },
  "details": {
    "heading": "Why Orthodontics?",
    "text": "Orthodontics corrects teeth and jaw structure issues to ensure proper bite, aesthetic smile, and oral health. Suitable for both children and adults."
  },
  "steps": [
    "Examination and diagnosis",
    "Teeth and jaw measurements",
    "Braces or appliance application",
    "Follow-up and adjustments"
  ],
  "advantages": {
    "heading": "Orthodontics Advantages",
    "items": [
      { "title": "Aligned Teeth", "desc": "Provides an aesthetic and proper teeth arrangement." },
      { "title": "Proper Chewing", "desc": "Optimizes chewing function." },
      { "title": "Long-term Health", "desc": "Protects dental health and prevents wear." },
      { "title": "Boosted Confidence", "desc": "Enhances self-confidence with smile design." }
    ]
  }
},
notFound: {
  seoTitle: "Page Not Found - Dt. Mert Sakarya Dental Clinic",
  seoDescription: "The page you're looking for could not be found. Head back to the homepage to explore Dt. Mert Sakarya Dental Clinic's services.",
  heading: "404",
  title: "Page Not Found",
  text: "The page you're looking for may have been removed, moved, or never existed.",
  backHome: "Back to Homepage",
}
};
export default en;